import { createFileRoute } from "@tanstack/react-router";
import { FnbPage } from "../../components/participant/fnb-page";

/** `/me/fnb` — every participant: their meals follow their card and their room. The API is keyed on the login. */
export const Route = createFileRoute("/_app/me/fnb")({
	component: FnbPage,
});
